const year = document.getElementById("year");
if (year) {
    const y = new Date().getFullYear();
    console.log({ y });
    year.textContent = y;
}
